import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'react-use'
import BtnLiquid from './BtnLiquid'
import Button from '../elements/Button'
import globals from '../globals'
import Carousel from 'react-elastic-carousel'

const ComparePlansMobile = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const isTabletPortrait = useMedia('(min-width: 768px) and (max-width: 1024px)')

    const planRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null)
    ]

    const Plans = () => {

        return props.plans.map((plan, key) => {
            const newPlan = (props.selectedPlan.planType == plan.planType)
            return (
                <div key={key} ref={planRefs[key]} className='plan' id={`plan-${plan.id}`}>
                    <div className="inner">
                        <div className={`${newPlan ? 'new-title' : 'title'} mb-3`}>
                            <div className='p-3'>
                                <div className='color-white mb-2'>{plan.subHeading}</div>
                                <h4 className='m-0 color-lime font-xlarge bold'>{plan.heading}</h4>
                            </div>
                        </div>
                        <div className={plan.priceNotes && plan.priceNotes.length > 0 ? 'mb-4' : ''}>
                            <p className={`bold m-0 font-xlarge py-2 pb-2 ${plan.priceNotes && plan.priceNotes.length > 0 ? 'mb-2': 'mb-3'}`}>{globals.formatDecimals(plan.price, true)}</p>
                            {plan.priceNotes && plan.priceNotes.length > 0 ?
                                plan.priceNotes.map((item) => {
                                    return (
                                       item !== " " ? <p key={item} className='m-0 mb-1'>{item}</p> : <div style={{marginBottom: '4.6875rem'}} />
                                    )
                                }): <div style={{marginBottom: '4.6875rem'}} />
                            }
                        </div>
                        <div className='separator' />
                        <div className="mb-4 plan-data">
                            <p className='mb-2 font-xlarge data-title bold color-lime'>{plan.data}</p>
                            {plan.newCustomerPromotion ? <p className='m-0 mb-1 color-lime'>{plan.newCustomerPromotion}</p> : ""}
                        </div>
                        {plan.specialText ? <p className='m-0 mt-1 font-tiny'>{plan.specialText}</p> : ''}
                        <div className='separator' />
                        <ul className='mt-3'>
                            {plan.features && plan.features.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <div className="tick"><IconTick /></div>
                                        <div dangerouslySetInnerHTML={{__html: item}} />
                                    </li>
                                )
                            })}
                        </ul>
                        <div className='btn-spacer' />
                        <div className='bottom d-none d-lg-block'>
                            <div className='separator  mb-3' />
                            <p className='my-3 text-center'>Total min {globals.formatDecimals(plan.price, true)} | {globals.formatDecimals(plan.costPerGb, true)}/GB</p>
                            {props.isExistingCustomer
                                ? <BtnLiquid color='lightGrey' handleClick={() => {}}>
                                    <a href='https://my.exetel.com.au/sim-only-plan' target='_blank' style={{ color: '#004346' }} rel='noreferrer'>Add now via My Exetel</a>
                                  </BtnLiquid>
                                : <BtnLiquid color='lightGrey' handleClick={event => props.handleClickBuyNow(event, plan.id)}>Buy now</BtnLiquid>}
                        </div>
                        <div className='bottom-container d-lg-none pb-2'>
                            <div className='separator  mb-2' />
                            <p className='m-0 mb-2 font-tiny text-center'>Total min {globals.formatDecimals(plan.price, true)} | {globals.formatDecimals(plan.costPerGb, true)}/GB</p>
                            <div className='btn-bottom'>
                                {props.isExistingCustomer
                                    ? <Button href='https://my.exetel.com.au/sim-only-plan' handleClick={() => {}}>Add now via My Exetel</Button>
                                    : <Button action={event => props.handleClickBuyNow(event, plan.id)}>Buy now</Button>}
                            </div>
                        </div>
                    </div>

                </div>
            )
        })
    }

    const CarouselMobile = <Carousel className='compare-plans-mobile' itemsToShow={1} initialFirstItem={2} showArrows={false} children={Plans()} />
    const CarouselTablet = <Carousel className='compare-plans-mobile' itemsToShow={2} initialFirstItem={4} children={Plans()} showArrows={false} />
    const CarouselDesktop = <Carousel className='compare-plans-mobile' itemsToShow={4} initialFirstItem={4} children={Plans()} showArrows outerSpacing={30} />

    return (
        isMobile ? (isTabletPortrait ? CarouselTablet : CarouselMobile) : CarouselDesktop
    )
}

const ShowMoreList = (props) => {
    const [showMore, setShowMore] = useState(true)

    const handleClickShowMore = () => {
        setShowMore(!showMore)
    }

    return (
        <li>
            {props.item.length > 100
                ? <span>{showMore ? props.item.substring(0, 46) : props.item}
                    <a onClick={handleClickShowMore}>{showMore ? '...more' : ''} </a>
                  </span>
                : props.item}
        </li>
    )
}

const IconTick = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M18.9053 10.3637C19.3223 9.94678 19.3223 9.27079 18.9053 8.85384C18.4884 8.4369 17.8124 8.4369 17.3954 8.85384L10.6768 15.5724L8.22884 13.1244C7.8119 12.7075 7.1359 12.7075 6.71896 13.1244C6.30201 13.5414 6.30201 14.2174 6.71896 14.6343L9.9219 17.8373C10.3388 18.2542 11.0148 18.2542 11.4318 17.8373L18.9053 10.3637Z" fill="#00CE5F"/>
        </svg>
    )
}

ComparePlansMobile.propTypes = {
    plans: PropTypes.array.isRequired,
    selectedPlan: PropTypes.object,
    startPosition: PropTypes.number,
    handleClickBuyNow: PropTypes.func.isRequired
}

ComparePlansMobile.defaultProps = {
    plans: [],
    selectedPlan: {},
    startPosition: 0
}

export default ComparePlansMobile



// WEBPACK FOOTER //
// ./resources/js/components/ComparePlansMobile.js